// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import JoditEditor from 'jodit-react';
// import 'react-toastify/dist/ReactToastify.css';

// const EditBlog = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();

//     const [formData, setFormData] = useState({
//         title: '',
//         snippet: '',
//         content: '',
//         status: false,
//     });

//     const [image, setImage] = useState(null);
//     const [existingImage, setExistingImage] = useState(null);
//     const [isLoading, setIsLoading] = useState(false);

//     // Fetch blog data on load
//     useEffect(() => {
//         const fetchBlog = async () => {
//             try {
//                 const res = await axios.get(`https://api.sofiasurgicals.com/api/get-single-blog/${id}`);
//                 const { title, snippet, content, status, image } = res.data;
//                 setFormData({ title, snippet, content, status });
//                 setExistingImage(image); // existing image path
//             } catch (err) {
//                 console.error(err);
//                 toast.error("Failed to fetch blog details.");
//             }
//         };

//         fetchBlog();
//     }, [id]);

//     // Handlers
//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [name]: type === 'checkbox' ? checked : value,
//         }));
//     };

//     const handleContentChange = (newContent) => {
//         setFormData((prev) => ({ ...prev, content: newContent }));
//     };

//     const handleImageChange = (e) => {
//         setImage(e.target.files[0]);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);

//         const data = new FormData();
//         data.append('title', formData.title);
//         data.append('snippet', formData.snippet);
//         data.append('content', formData.content);
//         data.append('status', formData.status);

//         if (image) data.append('image', image);

//         try {
//             await axios.put(`https://api.sofiasurgicals.com/api/update-blog/${id}`, data, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });
//             toast.success("Blog updated successfully!");
//             navigate("/all-blog");
//         } catch (error) {
//             console.error(error);
//             toast.error(error.response?.data?.message || "Failed to update blog.");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     return (
//         <>
//             <ToastContainer />
//             <div className="bread d-flex justify-between items-center mb-4">
//                 <h4>Edit Blog</h4>
//                 <Link to="/all-blog" className="btn btn-secondary">
//                     <i className="fa-regular fa-circle-left"></i> Back
//                 </Link>
//             </div>

//             <form className="row g-3" onSubmit={handleSubmit}>
//                 <div className="col-md-4">
//                     <label className="form-label">Title</label>
//                     <input
//                         type="text"
//                         name="title"
//                         className="form-control"
//                         value={formData.title}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>

//                 <div className="col-md-4">
//                     <label className="form-label">Snippet</label>
//                     <input
//                         type="text"
//                         name="snippet"
//                         className="form-control"
//                         value={formData.snippet}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>

//                 <div className="col-md-4">
//                     <label className="form-label">Image</label>
//                     <input
//                         type="file"
//                         name="image"
//                         className="form-control"
//                         onChange={handleImageChange}
//                     />
//                     {existingImage && !image && (
//                         <img
//                             src={`https://api.sofiasurgicals.com/${existingImage}`}
//                             alt="Existing"
//                             width="60"
//                             className="mt-2 d-block"
//                         />
//                     )}
//                 </div>

//                 <div className="col-md-12">
//                     <label className="form-label">Content</label>
//                     <JoditEditor
//                         value={formData.content}
//                         onChange={handleContentChange}
//                         config={{ readonly: false }}
//                     />
//                 </div>

//                 <div className="col-md-6 form-check">
//                     <input
//                         type="checkbox"
//                         name="status"
//                         className="form-check-input"
//                         checked={formData.status}
//                         onChange={handleChange}
//                         id="statusCheckbox"
//                     />
//                     <label className="form-check-label" htmlFor="statusCheckbox">
//                         Active
//                     </label>
//                 </div>

//                 <div className="col-12 text-center">
//                     <button
//                         type="submit"
//                         className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}
//                         disabled={isLoading}
//                     >
//                         {isLoading ? 'Please Wait...' : 'Update Blog'}
//                     </button>
//                 </div>
//             </form>
//         </>
//     );
// };

// export default EditBlog;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate, useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import 'react-toastify/dist/ReactToastify.css';

const EditBlog = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        title: '',
        snippet: '',
        content: '',
        status: false,
        seoTitle: '',
        urlSlug: '',
        metaDescription: '',
        metaKeywords: '',
    });

    const [image, setImage] = useState(null);
    const [existingImage, setExistingImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const res = await axios.get(`https://api.sofiasurgicals.com/api/get-single-blog/${id}`);
                const {
                    title, snippet, content, status, image,
                    slug, seoTitle, metaDescription, metaKeywords,
                } = res.data;

                setFormData({
                    title: title || '',
                    snippet: snippet || '',
                    content: content || '',
                    status: !!status,
                    seoTitle: seoTitle || '',
                    urlSlug: slug || '',
                    metaDescription: metaDescription || '',
                    metaKeywords: metaKeywords || '',
                });
                setExistingImage(image);
            } catch (err) {
                console.error(err);
                toast.error("Failed to fetch blog details.");
            } finally {
                setIsFetching(false);
            }
        };

        fetchBlog();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleContentChange = (newContent) => {
        setFormData((prev) => ({ ...prev, content: newContent }));
    };

    const handleMetaKeywordsChange = (metaKeywords) => {
        setFormData((prev) => ({ ...prev, metaKeywords }));
    };

    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const data = new FormData();
        data.append('title', formData.title);
        data.append('snippet', formData.snippet);
        data.append('content', formData.content);
        data.append('status', formData.status);
        data.append('urlSlug', formData.urlSlug);
        data.append('seoTitle', formData.seoTitle);
        data.append('metaDescription', formData.metaDescription);
        data.append('metaKeywords', formData.metaKeywords);

        if (image) data.append('image', image);

        try {
            await axios.put(`https://api.sofiasurgicals.com/api/update-blog/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            toast.success("Blog updated successfully!");
            navigate("/all-blog");
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "Failed to update blog.");
        } finally {
            setIsLoading(false);
        }
    };

    if (isFetching) {
        return <p className="text-center mt-4">Loading blog details...</p>;
    }

    return (
        <>
            <ToastContainer />
            <div className="bread d-flex justify-between items-center mb-4">
                <h4>Edit Blog</h4>
                <Link to="/all-blog" className="btn btn-secondary">
                    <i className="fa-regular fa-circle-left"></i> Back
                </Link>
            </div>

            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-4">
                    <label className="form-label">Title</label>
                    <input
                        type="text"
                        name="title"
                        className="form-control"
                        value={formData.title}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Snippet</label>
                    <input
                        type="text"
                        name="snippet"
                        className="form-control"
                        value={formData.snippet}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Image</label>
                    <input
                        type="file"
                        name="image"
                        className="form-control"
                        onChange={handleImageChange}
                    />
                    {existingImage && !image && (
                        <img
                            src={`https://api.sofiasurgicals.com/${existingImage}`}
                            alt="Existing"
                            width="60"
                            className="mt-2 d-block"
                        />
                    )}
                </div>

                <div className="col-md-12">
                    <label className="form-label">Content</label>
                    <JoditEditor
                        value={formData.content}
                        onChange={handleContentChange}
                        config={{ readonly: false }}
                    />
                </div>

                {/* SEO */}

                <div className="col-md-4">
                    <label className="form-label">Page Title (SEO)</label>
                    <input
                        type="text"
                        name="seoTitle"
                        className="form-control"
                        value={formData.seoTitle}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label">URL Slug</label>
                    <input
                        type="text"
                        name="urlSlug"
                        className="form-control"
                        value={formData.urlSlug}
                        onChange={handleChange}
                    />
                    <small className="text-muted">
                        Changing this will update the live URL — old links will break.
                    </small>
                </div>

                <div className="col-md-4">
                    <label className="form-label">Meta Description</label>
                    <input
                        type="text"
                        name="metaDescription"
                        className="form-control"
                        value={formData.metaDescription}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-12">
                    <label className="form-label">Meta Keywords</label>
                    <JoditEditor
                        value={formData.metaKeywords}
                        onChange={handleMetaKeywordsChange}
                        config={{ readonly: false }}
                    />
                </div>

                <div className="col-md-6 form-check">
                    <input
                        type="checkbox"
                        name="status"
                        className="form-check-input"
                        checked={formData.status}
                        onChange={handleChange}
                        id="statusCheckbox"
                    />
                    <label className="form-check-label" htmlFor="statusCheckbox">
                        Active
                    </label>
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Please Wait...' : 'Update Blog'}
                    </button>
                </div>
            </form>
        </>
    );
};

export default EditBlog;